<template>
  <div class="box">
    <div class="first">
      <div class="top">
        <img :src="firstIcon">
        <p>保持233小游戏在手机快捷栏内，所有日常红包将获得额外加成。</p>
      </div>
      <img :src="quickPic">
    </div>
    <div class="second">
      <img :src="secondIcon">
      <p>
        <span>点击</span><span class="certifiedText">【前往认证】</span><span>则自动关闭233小游戏，返回桌面。将233小游戏放入快捷栏中再次启动即可生效。</span>
      </p>
    </div>
    <div class="third">
      <button class="goToCertified" @click="certified()">前往认证</button>
    </div>
  </div>
</template>
  
<script>
import quickPic from '@/assets/images/operate_gif.gif';
import firstIcon from '@/assets/images/firstIcon.svg';
import secondIcon from '@/assets/images/secondIcon.svg';

export default {
  name: 'ShortcutBar',
  data() {
    return {
      quickPic: quickPic,
      firstIcon: firstIcon,
      secondIcon: secondIcon,
      redBg: false
    }
  },
  methods: {
    certified() {
      Android.closeApp();
    }
  },
}
</script>
  
<style lang="less" scoped>
.box {
  width: 100%;
  text-align: center;
}
.top {
  margin-top: 0.21rem;
}
.first > img {
  width: 1.563rem;
  margin: 0.165rem auto;
}
.third {
  margin-top: 0.495rem;
}
.top > img,
.second > img {
  width: 0.32rem;
  height: 0.32rem;
  vertical-align: middle;
}
.top > p,
.second > p {
  width: 2.527rem;
  vertical-align: middle;
  margin-left: 0.157rem;
  display: inline-block;
  text-align: left;
  font-size: 0.1458rem;
  line-height: 0.2175rem;
}
.second > p {
  color: #333;
}
.second > p > .certifiedText {
  color: #ff5b22;
}
.goToCertified {
  width: 3.146rem;
  padding: .09rem 0;
  text-align: center;
  color: #fff;
  font-size: 0.1875rem;
  line-height: .28rem;
  background: #ff9500;
  border: 0;
  border-radius: 0.22875rem;
}
</style>